import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { ZegoUIKitPrebuilt } from "@zegocloud/zego-uikit-prebuilt";
import { getAuthUserlocal } from "../../store/services";
import axios from "axios";
import { getURLbyEndPointV2 } from "../../store/api";
import { Spinner } from "react-bootstrap";

const PublicCloudMeetingRoom = () => {
  const { meetingRoomId } = useParams();
  const [loading, setLoading] = useState(true);
  const [meetingValid, setMeetingValid] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [joinStatus, setJoinStatus] = useState("INIT"); // INIT, REQUESTED, WAIT, ALLOWED
  const [pollingInfo, setPollingInfo] = useState(null); // intervalId
  const [participantId, setParticipantId] = useState("");
  const [participantName, setParticipantName] = useState("");
  const [meetingData, setMeetingData] = useState(null);

  // Hardcoded credentials
  const appID = 1871154113;
  const serverSecret = "7625a483cfcaa01920c9f3ceeaab8ff2";

  useEffect(() => {
    const checkMeeting = async () => {
      try {
        const user = getAuthUserlocal();
        let queryParams = "";
        if (user && user.email) {
          queryParams = `?email=${encodeURIComponent(user.email)}`;
        }

        const url = getURLbyEndPointV2("getCloudMeeting", meetingRoomId);
        const finalUrl = url.replace(":id", meetingRoomId) + queryParams;

        const res = await axios.get(finalUrl);
        if (res.data.status) {
          setMeetingValid(true);
          setMeetingData(res.data.data);

          let userId = user?._id;
          if (!userId) {
            const sessionUserId = sessionStorage.getItem("guestUserId");
            if (sessionUserId) {
              userId = sessionUserId;
            } else {
              userId = "guest_" + Math.floor(Math.random() * 10000000);
              sessionStorage.setItem("guestUserId", userId);
            }
          }
          setParticipantId(userId);

          let userName = user
            ? `${user.firstName || ""} ${user.surName || ""}`.trim()
            : "";
          if (!userName) {
            const queryParamsCheck = new URLSearchParams(
              window.location.search,
            );
            userName =
              queryParamsCheck.get("name") ||
              "Participant_" + userId.split("_")[1];
          }
          setParticipantName(userName);

          checkInitialStatus(userId, userName, user?.email || "");
        } else {
          setMeetingValid(false);
          setErrorMessage("Meeting not found or invalid.");
        }
      } catch (error) {
        console.error("Meeting check failed", error);
        setMeetingValid(false);
        setErrorMessage(
          error.response?.data?.message ||
            "An error occurred while validating the meeting.",
        );
        setLoading(false);
      }
    };

    checkMeeting();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [meetingRoomId]);

  const checkInitialStatus = async (userId, userName, email) => {
    try {
      const res = await axios.post(getURLbyEndPointV2("checkJoinStatus"), {
        meetingRoomId,
        userId: userId,
      });
      if (res.data.status && res.data.allowed) {
        setJoinStatus("ALLOWED");
        setLoading(false);
      } else {
        requestToJoin(userId, userName, email);
      }
    } catch (error) {
      console.error("Check status failed:", error);
      setLoading(false);
    }
  };

  const requestToJoin = async (userId, userName, email) => {
    try {
      setJoinStatus("REQUESTED");
      const res = await axios.post(getURLbyEndPointV2("requestJoin"), {
        meetingRoomId,
        userId: userId,
        name: userName,
        email: email,
        role: "Participant",
      });

      if (res.data.status) {
        if (res.data.allowed) {
          setJoinStatus("ALLOWED");
          setLoading(false);
        } else {
          setJoinStatus("WAITING");
          setLoading(false);
          startPolling(userId);
        }
      }
    } catch (error) {
      console.error("Request join failed:", error);
      setLoading(false);
    }
  };

  const startPolling = (userId) => {
    const interval = setInterval(async () => {
      try {
        const res = await axios.post(getURLbyEndPointV2("checkJoinStatus"), {
          meetingRoomId,
          userId: userId,
        });
        if (res.data.status && res.data.allowed) {
          setJoinStatus("ALLOWED");
          clearInterval(interval);
        }
      } catch (e) {
        console.error(e);
      }
    }, 3000); // Check every 3 seconds
    setPollingInfo(interval);
  };

  useEffect(() => {
    return () => {
      if (pollingInfo) clearInterval(pollingInfo);
    };
  }, [pollingInfo]);

  const zpRef = React.useRef(false);

  const initMeeting = async (element) => {
    if (!element || zpRef.current) return;
    zpRef.current = true;

    const kitToken = ZegoUIKitPrebuilt.generateKitTokenForTest(
      appID,
      serverSecret,
      meetingRoomId,
      participantId,
      participantName,
    );

    // const getDynamicHeader = () => {
    //   if (!meetingData) return "AECCI-IAC";
    //   let formattedDate = "";
    //   if (meetingData.meetingDate) {
    //     const d = new Date(meetingData.meetingDate);
    //     const DD = String(d.getDate()).padStart(2, "0");
    //     const MM = String(d.getMonth() + 1).padStart(2, "0");
    //     const YYYY = d.getFullYear();
    //     formattedDate = `${DD}/${MM}/${YYYY}`;
    //   }
    //   let formattedTime = meetingData.meetingTime || "";
    //   if (formattedTime) {
    //     const [hours, minutes] = formattedTime.split(":");
    //     const hoursInt = parseInt(hours, 10);
    //     const ampm = hoursInt >= 12 ? "PM" : "AM";
    //     const displayHours = hoursInt % 12 || 12;
    //     formattedTime = `${String(displayHours).padStart(2, "0")}:${minutes}${ampm}`;
    //   }
    //   return `AECCI-IAC, ${meetingData.meetingTitle || "Meeting"}, ${formattedDate} ${formattedTime}`.trim();
    // };

    const zp = ZegoUIKitPrebuilt.create(kitToken);
    zp.joinRoom({
      container: element,
      scenario: {
        mode: ZegoUIKitPrebuilt.VideoConference,
      },
      showPreJoinView: false,
      branding: {
        logoURL:
          "https://www.aecci.org.in/wp-content/uploads/2020/10/AECCI-24.png",
        // headerTitle: getDynamicHeader(),
      },
      layout: "Grid",
      showScreenSharingButton: false,
      showMyCameraToggleButton: true, // Allow turning on camera
      showMyMicrophoneToggleButton: false, // Disallow mic
      showAudioVideoSettingsButton: true,
      showLeavingView: true,
      showLeaveRoomConfirmDialog: true,
      showUserList: true,
      showTextChat: true,
      turnOnCameraWhenJoining: false,
      turnOnMicrophoneWhenJoining: false, // Mic off initially
      sharedLinks: [
        {
          name: "Join link",
          url: window.location.href,
        },
      ],
      onLeaveRoom: () => {
        window.location.href = "/";
      },
    });
  };

  return (
    <div
      style={{
        width: "100vw",
        height: "100vh",
        backgroundColor: "#0B1A33",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden",
      }}
    >
      {loading ? (
        <div className="text-white text-center">
          <Spinner animation="border" />
          <p className="mt-2">Validating Meeting...</p>
        </div>
      ) : joinStatus === "WAITING" || joinStatus === "REQUESTED" ? (
        <div className="text-white text-center p-4">
          <Spinner animation="grow" variant="light" />
          <h3 className="mt-3">Waiting for Host Approval...</h3>
          <p>Please stay on this screen until the Host lets you in.</p>
        </div>
      ) : meetingValid && joinStatus === "ALLOWED" ? (
        <>
          <style>{`
            .custom-meeting-banner {
              position: absolute;
              top: 10px;
              left: 50%;
              transform: translateX(-50%);
              padding: 10px 20px;
              background: #19649D;
              color: white;
              font-size: 18px;
              font-weight: 600;
              border-radius: 8px;
              z-index: 9999;
              text-align: center;
              white-space: nowrap;
            }
            @media (max-width: 768px) {
              .custom-meeting-banner {
                width: 100vw;
                max-width: 100vw;
                top: 0;
                border-radius: 0;
                font-size: 13px;
                padding: 8px 10px;
                white-space: normal;
              }
            }
          `}</style>
          <div className="custom-meeting-banner">
            {meetingData
              ? (() => {
                  let formattedDate = "";
                  if (meetingData.meetingDate) {
                    const d = new Date(meetingData.meetingDate);
                    const DD = String(d.getDate()).padStart(2, "0");
                    const MM = String(d.getMonth() + 1).padStart(2, "0");
                    const YYYY = d.getFullYear();
                    formattedDate = `${DD}/${MM}/${YYYY}`;
                  }
                  let formattedTime = meetingData.meetingTime || "";
                  if (formattedTime) {
                    const [hours, minutes] = formattedTime.split(":");
                    const hoursInt = parseInt(hours, 10);
                    const ampm = hoursInt >= 12 ? "PM" : "AM";
                    const displayHours = hoursInt % 12 || 12;
                    formattedTime = `${String(displayHours).padStart(2, "0")}:${minutes}${ampm}`;
                  }
                  return `AECCI-IAC, ${meetingData.meetingTitle || "Meeting"}`.trim();
                })()
              : "AECCI-IAC"}
          </div>
          <div ref={initMeeting} style={{ width: "100%", height: "100%" }} />
        </>
      ) : (
        <div
          className="text-white text-center p-4"
          style={{ backgroundColor: "rgba(0,0,0,0.6)", borderRadius: "10px" }}
        >
          <h3>Access Denied / Invalid Meeting</h3>
          <p>{errorMessage || "You must be approved by the admin to join."}</p>
        </div>
      )}
    </div>
  );
};

export default PublicCloudMeetingRoom;
